/**
 * Welcome popup: exit-intent on desktop, timer on mobile.
 * Remembers dismissal in localStorage for 30 days.
 */
(function () {
  var STORAGE_KEY = 'richard_welcome_popup_seen';
  var EXPIRY_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
  var popup = document.querySelector('[data-welcome-popup]');
  if (!popup) return;

  function hasSeen() {
    try {
      var v = localStorage.getItem(STORAGE_KEY);
      if (!v) return false;
      var ts = parseInt(v, 10);
      if (isNaN(ts)) return false;
      return (Date.now() - ts) < EXPIRY_MS;
    } catch (_) { return false; }
  }

  function markSeen() {
    if (!window.RichardConsent || !window.RichardConsent.has('functional')) return;
    try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (_) {}
  }

  // Session-only dismissal — covers the case where the user declined
  // functional cookies (markSeen no-ops, so localStorage never persists).
  // Without this, the popup re-fires on every page nav within the visit.
  // sessionStorage auto-clears on tab close and does not require consent.
  var SESSION_KEY = 'richard_welcome_popup_dismissed';
  function isDismissedThisSession() {
    try { return sessionStorage.getItem(SESSION_KEY) === '1'; } catch (_) { return false; }
  }
  function markDismissedThisSession() {
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (_) {}
  }

  // Focus trap state
  var previouslyFocused = null;
  var trapHandler = null;

  function trapFocus() {
    previouslyFocused = document.activeElement;
    trapHandler = function (e) {
      if (e.key !== 'Tab') return;
      var focusables = popup.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', trapHandler);
    var firstFocusable = popup.querySelector('[data-welcome-popup-close], a[href], button:not([disabled]), input:not([disabled])');
    if (firstFocusable) firstFocusable.focus();
  }

  function releaseFocus() {
    if (trapHandler) {
      document.removeEventListener('keydown', trapHandler);
      trapHandler = null;
    }
    if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
      previouslyFocused.focus();
    }
    previouslyFocused = null;
  }

  function show() {
    if (hasSeen() || isDismissedThisSession() || popup.classList.contains('is-open')) return;
    popup.hidden = false;
    requestAnimationFrame(function () {
      popup.classList.add('is-open');
      trapFocus();
    });
    document.body.classList.add('welcome-popup-open');
  }

  function close() {
    popup.classList.remove('is-open');
    document.body.classList.remove('welcome-popup-open');
    markDismissedThisSession();
    markSeen();
    releaseFocus();
    setTimeout(function () { popup.hidden = true; }, 300);
  }

  if (hasSeen() || isDismissedThisSession()) return;

  // Mobile: open after 20 seconds
  var isMobile = window.matchMedia('(max-width: 749px)').matches;
  if (isMobile) {
    setTimeout(show, 20000);
  } else {
    // Desktop: open on mouse-leave from the top of the viewport
    document.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 0) show();
    });
    // Also open after 45s as fallback
    setTimeout(show, 45000);
  }

  // Bind close handlers
  popup.querySelectorAll('[data-welcome-popup-close]').forEach(function (btn) {
    btn.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
  });
})();
